import gql from 'graphql-tag';

export const newCollectionData = gql`
    query NewCollectionData($input: NewCollectionInput!) {
        newCollectionData(input: $input) {
            presignedUrl
        }
    }
`;

export const newCollectionDataOptions = {
  name: 'newCollection',
};
